<script>
  import Select from 'svelte-select';
  import { onMount } from 'svelte';
  import { client } from 'root/api/index.js';
  import InfiniteScroll from 'components/DataTable/InfiniteScroll.svelte';
  import Loader from '../Loader.svelte';
  import { Modal } from 'bootstrap';
  import { getContext, onDestroy, createEventDispatcher } from 'svelte';
  import { checkRole } from '../../stores/auth.js';
  import { configItem } from 'components/Helper.js';

  export let type = 1;
  import ReportFilter from './ReportFilter.svelte';

  const showDialog = getContext('showDialog');
  const dispatch = createEventDispatcher();
  let pageSize = 30;
  let pageNumber = 1;
  let totalPages = 0;
  let reportsList = [];
  let isPaginationLoading = false;
  let searchFilterReportTimeout;
  let filterType = '';
  let radioButton = { All: '', Manager: 1, 'General User': 0 };
  const getTaskFilterReportList = () => {
    searchFilterReportTimeout && clearTimeout(searchFilterReportTimeout);
    searchFilterReportTimeout = setTimeout(() => {
      isPaginationLoading = true;
      client
        .taskFilterReportList(pageSize, pageNumber, {
          searchKeyword: reportKeyword,
          type: type,
          filterType: filterType,
        })
        .then((response) => {
          isPaginationLoading = false;
          if (response.data.pagination.pageNumber == 1) {
            reportsList = response.data.payload;
          } else {
            reportsList = [...reportsList, ...response.data.payload];
          }
          totalPages = response.data.pagination.totalPage;
        });
    }, 500);
  };

  let taskReportModal;

  export const show = () => {
    taskReportModal = new Modal(document.getElementById('taskReportModal'), {
      keyboard: false,
    });
    reportsList = [];
    pageNumber = 1;
    filterType = '';
    taskReportModal.show();
    getTaskFilterReportList();
    reportKeyword = '';
  };

  const showDelete = (selectId) => {
    showDialog({
      isDeleteModel: true,
      type: 'confirm',
      title: '',
      message: 'Are you sure?',
      okFunc: () => {
        client
          .taskFilterReportDelete({ id: selectId })
          .then((response) => {
            reportsList = [];
            pageNumber = 1;
            getTaskFilterReportList();
          })
          .catch((err) => {
            showDialog({ message: err.message });
          });
      },
    });
  };

  // export let showGroup=()=>{

  // }
  let reportKeyword = '';
</script>

<!-- Modal -->
<div
  class="modal fade"
  id="taskReportModal"
  tabindex="-1"
  aria-labelledby="taskReportModal"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5
          class="modal-title font-size-14"
          id=""
        >
          Report
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body modal-body-height">
        {#if checkRole(configItem.roleIndex.user) == false}
          <div class="d-flex flex-row align-items-center py-2">
            <div class="col-md-4">
              <div class="radio c-radio">
                <label class="text-nowrap">
                  <input
                    type="radio"
                    name="filterType"
                    bind:group={filterType}
                    value=""
                    checked={filterType != 0 || filterType != 1}
                    on:change={(event) => {
                      getTaskFilterReportList();
                    }}
                  />
                  <span class="check-img" />
                  All
                </label>
              </div>
            </div>
            <div class="col-md-4">
              <div class="radio c-radio">
                <label class="text-nowrap">
                  <input
                    type="radio"
                    name="filterType"
                    bind:group={filterType}
                    value="1"
                    on:change={(event) => {
                      getTaskFilterReportList();
                    }}
                  />
                  <span class="check-img" />
                  Manager
                </label>
              </div>
            </div>
            <div class="col-md-4">
              <div class="radio c-radio">
                <label class="text-nowrap">
                  <input
                    type="radio"
                    name="filterType"
                    bind:group={filterType}
                    value="0"
                    on:change={(event) => {
                      getTaskFilterReportList();
                    }}
                  />
                  <span class="check-img" />
                  General User
                </label>
              </div>
            </div>
          </div>
        {/if}
        <div class="search-client-input position-relative">
          <img
            class="position-absolute"
            alt=""
            src="/images/search.svg"
          />
          <input
            class="form-control"
            bind:value={reportKeyword}
            on:keyup={(e) => {
              getTaskFilterReportList();
            }}
            placeholder="Search by report name"
            type="text"
          />
        </div>
        {#if reportsList.length == 0}
          <div class="my-4">
            <span class="color-lead text-center font-size-16 mt-2 d-block"
              >You have not created any reports yet. Select desired filters and click Save Report to
              create a new report.</span
            >
          </div>
        {/if}
        {#each reportsList as report}
          <div class="d-flex flex-row align-items-center group-list-items py-2">
            <div class="w-100 d-flex flex-column me-2">
              <span class="font-weight-400 font-size-14 text-break color-blue groups-name"
                >{report.name}</span
              >
            </div>
            <button
              on:click={() => {
                client
                  .taskFilterReportGet({ id: report.id })
                  .then((response) => {
                    taskReportModal.hide();
                    dispatch('select', response.data);
                    // showGroup("select",response.data)
                  })
                  .catch((err) => {
                    showDialog({
                      type: 'warning',
                      message: [err],
                    });
                  });
              }}
              class="btn-select shadow-none border-0"
            >
              Select
            </button>
            <button
              on:click={() => {
                client
                  .taskFilterReportGet({ id: report.id })
                  .then((response) => {
                    taskReportModal.hide();
                    dispatch('edit', response.data);
                    //showGroup("edit",response.data)
                  })
                  .catch((err) => {
                    showDialog({
                      type: 'warning',
                      message: [err],
                    });
                  });
              }}
              class="btn-select shadow-none border-0 ms-1"
            >
              Edit
            </button>

            <button
              on:click={() => {
                showDelete(report.id);
              }}
              class="btn-trash shadow-none border-0 ms-1"
            >
              Delete
            </button>
          </div>
        {/each}

        <InfiniteScroll
          threshold={300}
          hasMore={pageNumber < totalPages}
          isLoading={isPaginationLoading}
          on:loadMore={() => {
            pageNumber = pageNumber + 1;
            getTaskFilterReportList();
          }}
        >
          <div
            class="scroll-spinner-container d-flex justify-content-center
			align-items-center"
          >
            <Loader />
          </div>
        </InfiniteScroll>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="trans-btn my-0 px-4 font-size-12 outline-0 btn-cancel font-size-12"
          data-bs-dismiss="modal">Cancel</button
        >
      </div>
    </div>
  </div>
</div>

<style lang="scss">
  .group-list-items {
    border-bottom: 1px solid rgba($input-border-color, 0.4);
    .btn-trash {
      transition-duration: 0.2s;
      background: $red-color !important;
      color: $white-color;
      width: 70px;
      height: 25px;
      border-radius: 4px;
      line-height: 13px;
      border-radius: 0px;
      &:hover {
        background: rgba($input-border-color, 0.4);
      }
    }
    .btn-select {
      transition-duration: 0.2s;
      background: rgba($blue-color, 0.1);
      color: $blue-color;
      width: 70px;
      height: 25px;
      border-radius: 4px;
      line-height: 13px;
      border-radius: 0px;
      &:hover {
        background: rgba($input-border-color, 0.4);
      }
      &:focus {
        background: $input-border-color;
      }
    }
    &:last-child {
      border-bottom: 0px;
    }
  }
  .total-members-count {
    font-size: 11px;
  }
  .groups-name {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 335px;
  }
</style>
